import acDetailedRateCard from "./acDetailedRateCard";
import plumberDetailedRateCard from "./plumberDetailedRateCard";
import electricianDetailedRateCard from "./electricianDetailedRateCard";
import carpenterDetailedRateCard from "./carpenterDetailedRateCard";
import labourDetailedRateCard from "./labourDetailedRateCard";
import homeCleaningDetailedRateCard from "./homeCleaningDetailedRateCard";
import gardeningDetailedRateCard from "./gardeningDetailedRateCard";
import houseMaidDetailedRateCard from "./houseMaidDetailedRateCard";
import cookChefDetailedRateCard from "./cookChefDetailedRateCard";
import dogCareDetailedRateCard from "./dogCareDetailedRateCard";
import carCleaningDetailedRateCard from "./carCleaningDetailedRateCard";
import nannyCaretakerDetailedRateCard from "./nannyCaretakerDetailedRateCard";
import homeTutorDetailedRateCard from "./homeTutorDetailedRateCard";
import yogaInstructorDetailedRateCard from "./yogaInstructorDetailedRateCard";
import instaHelpDetailedRateCard from "./instaHelpDetailedRateCard";
import washingMachineDetailedRateCard from "./washingMachineDetailedRateCard";
import refrigeratorDetailedRateCard from "./refrigeratorDetailedRateCard";
import microwaveDetailedRateCard from "./microwaveDetailedRateCard";
import waterPurifierDetailedRateCard from "./waterPurifierDetailedRateCard";
import geyserDetailedRateCard from "./geyserDetailedRateCard";
import chimneyDetailedRateCard from "./chimneyDetailedRateCard";
import tvDetailedRateCard from "./tvDetailedRateCard";
import laptopDetailedRateCard from "./laptopDetailedRateCard";

export const detailedRateCards = [
  acDetailedRateCard,
  plumberDetailedRateCard,
  electricianDetailedRateCard,
  carpenterDetailedRateCard,
  labourDetailedRateCard,
  homeCleaningDetailedRateCard,
  gardeningDetailedRateCard,
  houseMaidDetailedRateCard,
  cookChefDetailedRateCard,
  dogCareDetailedRateCard,
  carCleaningDetailedRateCard,
  nannyCaretakerDetailedRateCard,
  homeTutorDetailedRateCard,
  yogaInstructorDetailedRateCard,
  instaHelpDetailedRateCard,
  washingMachineDetailedRateCard,
  refrigeratorDetailedRateCard,
  microwaveDetailedRateCard,
  waterPurifierDetailedRateCard,
  geyserDetailedRateCard,
  chimneyDetailedRateCard,
  tvDetailedRateCard,
  laptopDetailedRateCard,
];

export function getDetailedRateCardByKey(key) {
  return detailedRateCards.find((item) => item.key === key) || null;
}